import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { CddInternationalWiresVolumesForm } from './CddInternationalWiresVolumesForm';
import { useCddInternationalWiresLogic } from './hooks/useCddInternationalWiresLogic';

export const CddInternationalWiresVolumes = () => {
  const { t } = useTranslation('cddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useCddInternationalWiresLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('internationalWireVolumes.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <CddInternationalWiresVolumesForm
          contentKeys={{
            internationalWiresIncoming: 'internationalWireVolumes.internationalWiresIncoming',
            internationalWiresOutgoing: 'internationalWireVolumes.internationalWiresOutgoing',
          }}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
